import { render, staticRenderFns } from "./AddKeywordPopup.vue?vue&type=template&id=1a55edda&scoped=true"
import script from "./AddKeywordPopup.vue?vue&type=script&lang=js"
export * from "./AddKeywordPopup.vue?vue&type=script&lang=js"
import style0 from "./AddKeywordPopup.vue?vue&type=style&index=0&id=1a55edda&prod&lang=scss&scoped=true"
import style1 from "./AddKeywordPopup.vue?vue&type=style&index=1&id=1a55edda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a55edda",
  null
  
)

export default component.exports